module.exports = __webpack_public_path__ + "img/霾.4100a73b.png";